import AppLayout from '../layout/AppLayout';
import Home from './Home/Home';
import Experience from './Experience/Experience';
import Projects from './Projects/Projects';
import Skills from './Skills/Skills';

export default function Page() {
  return (
    <AppLayout>
      <Home />
      <Experience />
      <Projects />
      <Skills />
    </AppLayout>
  );
}
